import get from 'lodash/get';

export default function getSummaryFromState(state: object) {
  return get(state, 'eshop.summary');
}
